export const postponeCosts = [
  { situation: 'Sin una propuesta elegida', consequence: 'Seguís guardando imágenes sin arrancar.', positive: false },
  { situation: 'Sin revisar los materiales', consequence: 'Descubrís a último momento lo que te falta.', positive: false },
  { situation: 'Sin opciones para distintos gustos', consequence: 'Cuesta encontrar un personaje que entusiasme.', positive: false },
  { situation: 'Sin organizar los pasos', consequence: 'El armado se vuelve más complicado.', positive: false },
  { situation: 'Con una guía a mano', consequence: 'Podés elegir, preparar y avanzar en familia.', positive: true },
];
